<!-- data-repeat-click: the one place the double-click guard's opt-out is written. -->
<button
  type="button"
  data-repeat-click
  [class]="buttonClass()"
  [disabled]="disabled()"
  [attr.title]="tooltip()"
  [attr.aria-label]="label()"
  (click)="clicked.emit()"
>
  <ng-content />
</button>
